<template>
  <IconSvgBase
    :class="[$style.icon, $style[`icon--${direction}`]]"
    :view-width="24"
    :view-height="24"
  >
    <path
      :class="$style.icon__path"
      d="M12,15.5a1,1,0,0,1-.71-.29l-4-4A1,1,0,1,1,8.71,9.79L12,13.1l3.3-3.18a1,1,0,1,1,1.38,1.44l-4,3.86A1,1,0,0,1,12,15.5Z"
    />
  </IconSvgBase>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import { defineComponent } from 'vue'
import IconSvgBase from '@/components/icons/IconSvgBase.vue'

type Direction = 'up' | 'right' | 'down' | 'left'
export default defineComponent({
  name: 'IconChevron',
  components: {
    IconSvgBase,
  },
  props: {
    direction: {
      type: String as PropType<Direction>,
      default: 'down',
    },
  },
})
</script>

<style lang="scss" module>
.icon {
  display: inline-block;
  width: 1em;
  height: 1em;

  &__path {
    color: inherit;
    fill: currentcolor;
  }

  &--up {
    transform: rotate(180deg);
  }

  &--right {
    transform: rotate(270deg);
  }

  &--left {
    transform: rotate(90deg);
  }
}
</style>
